import { Block, Spacer, Vimeo } from "../../../../src/components/project/project";
import * as React from 'react';
export default {
  Block,
  Spacer,
  Vimeo,
  React
};